module.exports = __webpack_public_path__ + "static/Classroom-Activity-1-1-Appearance-Ideals-in-the-Media-0173043d883cc1509ddfb267d6aa91a6.pdf";